import { Action, createReducer, on } from '@ngrx/store';
import { IResendOtpRequest, IResendOtpResponse } from '../../../core/models/otp-resend.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { loadResendOtpRequest, loadResendOtpsSuccess, loadResendOtpsFailure, clearResendOtpSuccess } from '../actions/resend-otp.actions';

export const resendOtpFeatureKey = 'resendOtp';

export interface ResendOtpState {
  isLoading: boolean;
  loadResendOtp: IResendOtpRequest;
  loadResendOtpSuccess: IResendOtpResponse;
  loadResendOtpFailure: IGenericError<ErrorResponse>;
}

export const initialState: ResendOtpState = {
  isLoading: false,
  loadResendOtp: undefined,
  loadResendOtpSuccess: undefined,
  loadResendOtpFailure: undefined
};

export const reducer = createReducer(
  initialState,

  //#region REGISTER
  on(loadResendOtpRequest, (state, action) => ({
    ...state,
    loadResendOtp: action.request,
    isLoading: true
  })),
  on(loadResendOtpsSuccess, (state, action) => ({
    ...state,
    loadResendOtpSuccess: action.response,
    isLoading: false
  })),
  on(loadResendOtpsFailure, (state, action) => ({
    ...state,
    loadResendOtpFailure: action.error,
    isLoading: false
  })),
  on(clearResendOtpSuccess, (state, action) => ({
    ...state,
    loadResendOtpSuccess: undefined
  }))

  //#endregion
);

//#region REGISTER
export const getIsResendOtpLoading = (state: ResendOtpState) => state.isLoading;
export const getResendOtpRequest = (state: ResendOtpState) => state.loadResendOtp;
export const getResendOtpSuccess = (state: ResendOtpState) => state.loadResendOtpSuccess;
export const getResendOtpFailure = (state: ResendOtpState) => state.loadResendOtpFailure;

//#endregion
